import { useViewport } from '@/hooks/useViewport'
import type { FocalPoint } from '@/types'

const DEFAULT_FOCAL: FocalPoint = { x: 0.5, y: 0.5, scale: 1.0 }

type Props = {
  src: string
  alt: string
  settings?: { desktop: FocalPoint; mobile: FocalPoint }
  className?: string
  loading?: 'eager' | 'lazy'
  fetchPriority?: 'high' | 'low' | 'auto'
}

export default function SmartImage({
  src,
  alt,
  settings,
  className = '',
  loading,
  fetchPriority,
}: Props) {
  const viewport = useViewport()
  const pt = settings?.[viewport] ?? DEFAULT_FOCAL
  const reduceMotion =
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches

  return (
    <div className={`relative overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        loading={loading}
        // @ts-expect-error — fetchPriority is a valid HTML attribute, types lag
        fetchpriority={fetchPriority}
        className="w-full h-full"
        style={{
          objectFit: 'cover',
          objectPosition: `${pt.x * 100}% ${pt.y * 100}%`,
          transform: `scale(${pt.scale})`,
          transformOrigin: `${pt.x * 100}% ${pt.y * 100}%`,
          transition: reduceMotion
            ? 'none'
            : 'object-position 0.2s, transform 0.2s',
        }}
      />
    </div>
  )
}
